/** Where a tail begins: the live edge, the recent past, or the whole stream. */
export const TAIL_STARTS = ['now', 'last:50', 'last:500', 'all'] as const;
export type TailStart = (typeof TAIL_STARTS)[number];
